import React, { useState, useEffect } from 'react';
import Swal from "sweetalert2";
import { useUser } from '../context/UserContext';
import axios from 'axios';

const CancelConfirmation = ({ cancelDetails, onCancelSuccess, onClose }) => {
  const [loading, setLoading] = useState(false);
  const { selectedCenter, setSelectedCenter } = useUser();
  const { userData } = useUser();
  const { userId } = userData;
  const token = localStorage.getItem('auth-token');
  const masterId = cancelDetails[0]?.masterId;
  const handleCancel = async () => {
    const confirmDelete = await Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      text: "Do you really want to cancel this court booking?",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "Cancel",
    });

    if (!confirmDelete.isConfirmed) {
      return;
    }

    try {
      setLoading(true);
      const bookingIds = cancelDetails.map(item => item.masterId).join(',');
      
      const apiUrl = `${process.env.REACT_APP_API_CANCEL_COURT_BOOKING}?academyId=${selectedCenter}&bookingIds=${bookingIds}&loginUserId=${userId}`;
  
      const headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${token}`,
      };
      const response = await axios.post(apiUrl, {}, { headers });

      const { success, data } = response.data;

      if (success) {

        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Court cancelled successfully.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        onCancelSuccess(); 
        onClose();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: data?.errorMessage || "Unable to cancel booking.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Something went wrong while deleting.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
  
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div className="cancel-confirm-container">
    <h2 className="booking-title">Confirm Cancellation</h2>
    <button className="cancel-confirm-close-button" onClick={onClose}>×</button>
    <div className="cancel-confirm-details">
      {cancelDetails.map((detail, index) => (
        <div key={index} className="cancel-confirm-item">
          <div className="cancel-confirm-row">
            <span className="cancel-confirm-label">Court:</span>
            <span className="cancel-confirm-value">{detail.courtName}</span>
          </div>
          <div className="cancel-confirm-row">
            <span className="cancel-confirm-label">Time:</span>
            <span className="cancel-confirm-value">{detail.timeSlot}</span>
          </div>
          <div className="cancel-confirm-row">
            <span className="cancel-confirm-label">Name:</span>
            <span className="cancel-confirm-value">{detail.userName}</span>
          </div>
          <div className="cancel-confirm-row">
            <span className="cancel-confirm-label">Number:</span>
            <span className="cancel-confirm-value">{detail.userMobile}</span>
          </div>
        </div>
      ))}
    </div>
    <div className="cancel-confirm-buttons">
      <button
        className="cancelled-confirm-button"
        onClick={() => handleCancel(masterId)}
        disabled={loading}
      >
        {loading ? 'Processing...' : 'Confirm Cancellation'}
      </button>
    </div>
  </div>
  

  );
};

export default CancelConfirmation
